/**
 * Centralized development-only logging utility
 * Prevents console output in production builds
 */

/**
 * Logs messages only in development mode
 * @param args - Arguments to pass to console.log
 */
export const devLog = (...args: unknown[]): void => {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
};

/**
 * Logs warnings only in development mode
 * @param args - Arguments to pass to console.warn
 */
export const devWarn = (...args: unknown[]): void => {
  if (import.meta.env.DEV) {
    console.warn(...args);
  }
};

/**
 * Logs errors only in development mode
 * @param args - Arguments to pass to console.error
 */
export const devError = (...args: unknown[]): void => {
  if (import.meta.env.DEV) {
    console.error(...args);
  }
};

/**
 * Logs info messages only in development mode
 * @param args - Arguments to pass to console.info
 */
export const devInfo = (...args: unknown[]): void => {
  if (import.meta.env.DEV) {
    console.info(...args);
  }
};

/**
 * Logs debug messages only in development mode
 * @param args - Arguments to pass to console.debug
 */
export const devDebug = (...args: unknown[]): void => {
  if (import.meta.env.DEV) {
    console.debug(...args);
  }
};

// Attach to global scope for use without imports
// This allows devLog/devWarn/etc. to be used anywhere without explicit imports
if (typeof globalThis !== 'undefined') {
  (globalThis as Record<string, unknown>).devLog = devLog;
  (globalThis as Record<string, unknown>).devWarn = devWarn;
  (globalThis as Record<string, unknown>).devError = devError;
  (globalThis as Record<string, unknown>).devInfo = devInfo;
  (globalThis as Record<string, unknown>).devDebug = devDebug;
}
